import { render, staticRenderFns } from "./LocationWidget.vue?vue&type=template&id=bf1931fa&scoped=true"
import script from "./LocationWidget.vue?vue&type=script&lang=js"
export * from "./LocationWidget.vue?vue&type=script&lang=js"
import style0 from "./LocationWidget.vue?vue&type=style&index=0&id=bf1931fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1931fa",
  null
  
)

export default component.exports